import { Box } from '@mui/material';
import { useCallback } from 'react';
import TimerCircularTimer from './timer-circular-timer/timer-circular-timer.component';
import { useTimerProgress } from './timer-link.hooks';
import * as S from './timer-link.styles';

const TimerLink = ({ expiry, onClick, label }) => {
  const { progress, reset } = useTimerProgress(expiry);

  const handleClick = useCallback(() => {
    reset();
    onClick();
  }, [onClick, reset]);

  return (
    <Box
      display="flex"
      alignItems="center"
      margin="20px"
      justifyContent="center"
    >
      <TimerCircularTimer progress={progress} expiry={expiry} />
      <S.CustomTimerLink
        component="button"
        onClick={handleClick}
        disabled={progress < expiry}
        color="textPrimary"
        data-testid="TimerLink.CustomTimerLink"
      >
        {label}
      </S.CustomTimerLink>
    </Box>
  );
};
export default TimerLink;
